// Security Configuration - Headers and settings for API requests

// Security headers applied to all outgoing requests
export const SECURITY_HEADERS = {
  'X-Frame-Options': 'DENY',
  'X-Content-Type-Options': 'nosniff',
  'X-XSS-Protection': '1; mode=block',
  'Referrer-Policy': 'strict-origin-when-cross-origin',
  'Cache-Control': 'no-store, no-cache, must-revalidate, proxy-revalidate',
  'Pragma': 'no-cache',
  'Expires': '0',
  "SetAccesscontrol":false,
  "Access-Control-Allow-Origin": "*",
  "Access-Control-Allow-Headers": "Content-Type, Authorization",
};

// Content Security Policy directives
export const CSP_DIRECTIVES = {
  'default-src': "'self'",
  'script-src': "'self'",
  'style-src': "'self' 'unsafe-inline'",
  'img-src': "'self' data: https:",
  'font-src': "'self'",
  'connect-src': "'self'",
  'frame-ancestors': "'none'",
};

// Build CSP header string from directives
export const buildCSPHeader = () => {
  return Object.entries(CSP_DIRECTIVES)
    .map(([directive, value]) => `${directive} ${value}`)
    .join('; ');
};

// Cookie security settings
export const COOKIE_SETTINGS = {
  secure: true,
  httpOnly: true,
  sameSite: 'Strict',
  path: '/',
};

// Secure axios request configuration
export const SECURE_REQUEST_CONFIG = {
  withCredentials: true,
  validateStatus: (status) => status >= 200 && status < 300,
  maxContentLength: 50 * 1024 * 1024,
  maxBodyLength: 50 * 1024 * 1024,
};

// Fields to redact from logs
export const SENSITIVE_FIELDS = [
  'password',
  'token',
  'accessToken',
  'refreshToken',
  'authorization',
  'apiKey',
  'secret',
  'credential',
  'ssn',
  'creditCard',
  'cardNumber',
  'cvv',
  'pin',
];

// Sanitize object by removing sensitive fields for logging
export const sanitizeForLogging = (obj) => {
  if (!obj || typeof obj !== 'object') {
    return obj;
  }

  const sanitized = Array.isArray(obj) ? [...obj] : { ...obj };

  Object.keys(sanitized).forEach((key) => {
    const lowerKey = key.toLowerCase();
    
    // Check if key contains any sensitive field name
    const isSensitive = SENSITIVE_FIELDS.some((field) =>
      lowerKey.includes(field.toLowerCase())
    );

    if (isSensitive) {
      sanitized[key] = '[REDACTED]';
    } else if (typeof sanitized[key] === 'object' && sanitized[key] !== null) {
      sanitized[key] = sanitizeForLogging(sanitized[key]);
    }
  });

  return sanitized;
};

// Validate URL to prevent SSRF attacks
export const isValidUrl = (url) => {
  if (!url || typeof url !== 'string') {
    return false;
  }

  try {
    const parsedUrl = new URL(url);
    
    // Only allow HTTPS in production
    if (process.env.NODE_ENV === 'production' && parsedUrl.protocol !== 'https:') {
      console.warn('[Security] Non-HTTPS URL blocked in production:', url);
      return false;
    }

    // Block localhost/internal IPs in production (SSRF prevention)
    if (process.env.NODE_ENV === 'production') {
      const blockedHosts = ['localhost', '127.0.0.1', '0.0.0.0', '::1'];
      if (blockedHosts.includes(parsedUrl.hostname)) {
        console.warn('[Security] Internal URL blocked:', url);
        return false;
      }
    }

    return true;
  } catch (error) {
    console.warn('[Security] Invalid URL:', url);
    return false;
  }
};

export default {
  SECURITY_HEADERS,
  CSP_DIRECTIVES,
  COOKIE_SETTINGS,
  SECURE_REQUEST_CONFIG,
  SENSITIVE_FIELDS,
  buildCSPHeader,
  sanitizeForLogging,
  isValidUrl,
};
